import React, { useEffect, useState } from "react"
import { Modal, ModalBody, Button, Card, CardBody, CardText, CardTitle, Col, FormGroup, Input, Row, Spinner, Table } from "reactstrap"

import { useWallet } from "../../../libs/useMetaMaskWallet"
import Web3 from "web3"

import ConnectWallet from "../../../Components/ConnectWallet"
import BreadCrumb from "../../../Components/BreadCrumb"
import { formatNumber, rewardFromWei, safeNumber } from "../../../utils"
import { useToast } from "../../../hooks/toast"
import {
    approve,
    approveSob,
    stake,
    stakeSob,
    add,
    unStake,
    setComp,
    claim,
    claimSob,
    transferToDeployer,
    transferBalanceToDeployer,
    reLock
} from "../utils/stakingUtils"

import sobStakingAbi from "../../../abi/StakeTokenFixedLock.json"
import swdtknAbi from "../../../abi/SWDTKN.json"
const swdtknAddress = "0x968B493a2B27D03Dad92B9eA1e2E8232a72c9C2C"

const StakingSOB = ({ pool }) => {
    const web3 = new Web3()
    const [isLoading, setIsLoading] = useState(false)
    const [processing, setProcessing] = useState(false)
    const [isConnectedToWallet, setIsConnectedToWallet] = useState(false)
    const [claimAmount, setClaimAmount] = useState(0)
    const [stakeAmount, setStakeAmount] = useState(0)
    const [addStakeAmount, setAddStakeAmount] = useState(0)
    const [unStakeAmount, setUnstakeAmount] = useState(0)
    const [yourStakeAmount, setYourStakeAmount] = useState(0)
    const [oldStakeAmount, setOldStakeAmount] = useState(0)
    const [stakeIds, setStakeIds] = useState([])
    const [stakedAmountById, setStakedAmountById] = useState([])
    const [maxWithdrawById, setMaxWithdrawById] = useState(0)
    const [maxRewardsById, setMaxRewardsById] = useState(0)
    const [allowance, setAllowance] = useState(0)
    const [selectedId, setSelectedId] = useState("Select the Stake ID") // tokenId for claiming reward
    const [oldSelectedId, setOldSelectedId] = useState("Select the Stake ID") // tokenId for claiming reward
    const [selectedType, setSelectedType] = useState()
    const [selectedReward, setSelectedReward] = useState() // tokenId for claiming reward
    const [contractDetails, setContractDetails] = useState({ name: "Swords of Blood Staking Pool", symbol: "SWDSTK", totalSupply: 0 })
    const [claimableRewards, setClaimableRewards] = useState([]) // array of objects { id, reward }, where id == tokenId
    const [idoBalance, setIdoBalance] = useState(0)
    const [totalStaked, setTotalStaked] = useState(0)
    const [rewardTokens, setRewardTokens] = useState([{ symbol: "SWDTKN" }])
    const [selectedRewardToken, setSelectedRewardToken] = useState()
    const [currentStake, setCurrentStake] = useState()

    const [isCompounding, setIsCompounding] = useState(true)
    const [stakeTypes, setStakeTypes] = useState([{ value: 45 }, { value: 60 }, { value: 90 }, { value: 120 }, { value: 180 }, { value: 360 }])
    const [oldStakes, setOldStakes] = useState([])

    const toast = useToast()
    const wallet = useWallet()
    const minimumAmountToStake = 100

    const stakingDisabled = false // set true to disable staking UI

    const onRewardValueChange = (e, type) => {
        const value = isNaN(e.target.value) ? 0 : safeNumber(e.target.value)
        switch (type) {
            case "claim":
                setClaimAmount(value)
                break
            case "stake":
                setStakeAmount(value)
                break
            case "unstake":
                setUnstakeAmount(value)
                break
            case "add":
                setAddStakeAmount(value)
                break
            default:
                return
        }
    }

    const handleApprove = async (amount) => {
        web3.setProvider(wallet.ethereum.provider)
        approveSob(web3, pool, wallet.account, amount, setProcessing, setMessage, setAllowed)
    }

    const handleStake = async (amount) => {
        web3.setProvider(wallet.ethereum.provider)
        stakeSob(web3, pool, wallet.account, amount, selectedType, setProcessing, setMessage, handleResetForm)
    }

    const handleUnStake = async (tokenId, amount) => {
        web3.setProvider(wallet.ethereum.provider)
        unStake(web3, pool, wallet.account, tokenId, amount, setProcessing, setMessage, handleResetForm)
    }

    const handleClaim = async (tokenId, amount) => {
        web3.setProvider(wallet.ethereum.provider)
        claimSob(web3, pool, wallet.account, tokenId, amount, setProcessing, setMessage, handleResetForm)
    }

    const handleCompounding = async (tokenId, compounding) => {
        web3.setProvider(wallet.ethereum.provider)
        setComp(web3, pool, wallet.account, tokenId, !compounding, setProcessing, setMessage, handleResetForm)
    }

    const handleAddStake = async (tokenId, amount) => {
        web3.setProvider(wallet.ethereum.provider)
        add(web3, pool, wallet.account, tokenId, amount, setProcessing, setMessage, handleResetForm)
    }

    const handleReLock = async (tokenId) => {
        web3.setProvider(wallet.ethereum.provider)
        if (tokenId === currentStake.value) {
            reLock(web3, pool, wallet.account, tokenId, currentStake.stakeType, currentStake.compounding, setProcessing, setMessage, handleResetForm)
        } else {
            console.log("Error: Could not handle currentStake")
        }
    }

    const handleTransfer = async (tokenId) => {
        web3.setProvider(wallet.ethereum.provider)
        transferToDeployer(
            web3,
            { stakingAbi: pool.stakingAbi, stakingContractAddress: pool.stakingContractAddress, args: { maxPriorityFeePerGas: "0xba43b74000" } },
            wallet.account,
            tokenId,
            setProcessing,
            setMessage,
            handleResetForm
        )
    }

    const handleTransferBalance = async () => {
        web3.setProvider(wallet.ethereum.provider)
        transferBalanceToDeployer(
            web3,
            { tokenAbi: pool.tokenAbi, tokenContractAddress: pool.tokenContractAddress, args: { maxPriorityFeePerGas: "0xba43b74000" } },
            wallet.account,
            idoBalance,
            setProcessing,
            setMessage,
            handleResetForm
        )
        console.log("balance: ", idoBalance)
    }

    const handleResetForm = async () => {
        setClaimAmount(0)
        setStakeAmount(0)
        setUnstakeAmount(0)
        setAddStakeAmount(0)
        window.location.reload()
    }

    const setMessage = async (type, message) => {
        switch (type) {
            case "success":
                toast.addSuccess(message)
                break
            case "error":
                toast.addError(message)
                break
            case "info":
                toast.addInfo(message)
                break
            default:
                break
        }
    }

    const setAllowed = (amount) => {
        setAllowance(safeNumber(web3.utils.fromWei(amount, "ether")))
    }

    useEffect(() => {
        if (selectedId > 0) {
            let id = selectedId
            let tokenReward = selectedReward
            let arr = stakedAmountById
            let result = arr.find((el) => el.value == id)
            if (selectedReward !== "Select Reward Token" && selectedReward) {
                let result = claimableRewards[tokenReward].find((el) => el.tokenId == id)
                setMaxRewardsById(result.reward)

                let rewardToken = rewardTokens.find((el) => el.symbol == tokenReward)
                setSelectedRewardToken(rewardToken)
            }
            if (result) {
                setMaxWithdrawById(web3.utils.fromWei(result.amount, "ether"))
                // setMaxRewardsById(web3.utils.fromWei(result.reward, "ether"))
                setMaxRewardsById(result.reward)
                setCurrentStake(result)
            } else {
                setMaxWithdrawById(0)
                setMaxRewardsById(0)
                toast.addInfo("There is no stake or reward for the selected Id")
            }
        } else {
            setMaxWithdrawById(0)
            setMaxRewardsById(0)
        }
    }, [selectedId, selectedReward])

    useEffect(() => {
        ;(async () => {
            setIsLoading(true)
            if (updateConnection() && wallet.account && wallet.chainId === pool.chainId && pool) {
                web3.setProvider(wallet.ethereum.provider)
                try {
                    let tokenContract = new web3.eth.Contract(pool.tokenAbi, pool.tokenContractAddress)
                    let stakingContract = new web3.eth.Contract(pool.stakingAbi, pool.stakingContractAddress)
                    let stakingContractName = await stakingContract.methods.name().call()
                    let stakingSymbol = await stakingContract.methods.symbol().call()
                    setContractDetails({
                        name: stakingContractName,
                        symbol: stakingSymbol
                    })

                    // let stakeTypes = await stakingContract.methods.getStakeTypes().call()
                    // if (stakeTypes?.length > 0) {
                    //     let stakeTypesA = stakeTypes.map((type) => {
                    //         return { value: type.name, label: type.name }
                    //     })
                    //     stakeTypesA.shift()
                    //     setStakeTypes(stakeTypesA)
                    // }

                    let urStakeAmount = await stakingContract.methods.getStakeAmount(wallet.account).call()
                    let balance = await tokenContract.methods.balanceOf(wallet.account).call()
                    console.log("balance: " + balance)
                    let stakedBalance = await tokenContract.methods.balanceOf(pool.stakingContractAddress).call()
                    setIdoBalance(web3.utils.fromWei(balance, "ether"))
                    setTotalStaked(formatNumber(web3.utils.fromWei(stakedBalance, "ether")))
                    // let totalSupply = await stakingContract.methods.totalDepositAmount().call()

                    let allowancea = await tokenContract.methods.allowance(wallet.account, pool.stakingContractAddress).call()
                    setAllowance(safeNumber(web3.utils.fromWei(allowancea, "ether")))

                    let ids = await stakingContract.methods.getStakeTokenIds(wallet.account).call()
                    let idsA = ids.map((id) => {
                        return { value: id, label: id }
                    })
                    setStakeIds(idsA)

                    let stakedValuesById = await Promise.all(
                        ids.map(async (id) => {
                            let stake = await stakingContract.methods.stakes(id).call()
                            let reward = await stakingContract.methods.getAvailableClaim(id).call()

                            return {
                                value: id,
                                label: id,
                                amount: stake["0"],
                                depositedAt: stake["1"],
                                period: stake["2"],
                                reward: reward
                            }
                        })
                    )

                    setStakedAmountById(stakedValuesById)

                    setYourStakeAmount(web3.utils.fromWei(urStakeAmount, "ether"))

                    // check OLD Stake Tokens
                    // remove after all transferred

                    // let oldIGSPContract = new web3.eth.Contract(oldIGSP_ABI, oldIGSP_ADDRESS)

                    let claimableRewards = []
                    let tokenRewards = []

                    for (let r = 0; r < 1; r++) {
                        let address = swdtknAddress
                        let abi = swdtknAbi
                        let rewardTokenContract = new web3.eth.Contract(abi, address)
                        let symbol = await rewardTokenContract.methods.symbol().call()
                        let decimals = await rewardTokenContract.methods.decimals().call()
                        tokenRewards.push({ symbol, decimals, address, abi })
                        // for each tokenId, get its available reward
                        let claimableRewardsA = await Promise.all(
                            ids.map(async (id) => {
                                let rewardstart = await stakingContract.methods.getAvailableClaim(id).call()
                                let reward = await rewardFromWei(rewardstart, decimals)
                                return { tokenId: id, symbol, decimals, reward }
                            })
                        )
                        claimableRewards = claimableRewards.concat(claimableRewardsA)
                    }

                    setRewardTokens(tokenRewards)

                    function groupByToken(array, token) {
                        let value = array.reduce(function (total, item) {
                            let key = item[token]
                            total[key] = (total[key] || []).concat(item)
                            return total
                        }, {})
                        return value
                    }

                    let claimRewards = groupByToken(claimableRewards, "symbol")

                    setClaimableRewards(claimRewards)

                    setIsLoading(false)
                } catch (err) {
                    setIsLoading(false)
                    console.log(err)
                }
            }
        })()
    }, [wallet])

    const updateConnection = () => {
        const x = wallet.status === "connected" && wallet.chainId === pool.chainId
        setIsConnectedToWallet(x)
        return x
    }

    // FOR TESTING
    // const testClaimableRewards = [
    //     { id: 1, reward: "5,000" },
    //     { id: 2, reward: "15,000" }
    // ] // id == tokenId

    const showApproveButton = () => {
        return allowance < stakeAmount && !(stakeAmount < minimumAmountToStake) && !(stakeAmount > idoBalance)
    }
    const showAddApproveButton = () => {
        return allowance < addStakeAmount && !(addStakeAmount > idoBalance)
    }
    const disabledApproveButton = () => {
        return stakingDisabled || stakeAmount < minimumAmountToStake || stakeAmount > idoBalance || processing
    }
    const disabledAddApproveButton = () => {
        return stakingDisabled || addStakeAmount == 0 || addStakeAmount > idoBalance || processing
    }
    const disabledStakeButton = () => {
        return stakingDisabled || allowance < stakeAmount || stakeAmount < minimumAmountToStake || stakeAmount > idoBalance || processing
    }
    const disabledClaimButton = () => {
        return (
            !(selectedId > 0) ||
            !stakeIds.length ||
            selectedId === "Select the Stake ID" ||
            claimAmount > maxRewardsById ||
            claimAmount <= 0 ||
            processing
        )
    }
    const disabledUnstakeButton = () => {
        return Date.now() < currentStake?.releaseAt * 1000 || !(unStakeAmount > 0 && unStakeAmount <= maxWithdrawById) || processing
    }

    const disabledAddStakeButton = () => {
        return (
            stakingDisabled ||
            selectedId === "Select the Stake ID" ||
            !currentStake?.value ||
            isNaN(addStakeAmount) ||
            allowance < addStakeAmount ||
            addStakeAmount == 0 ||
            addStakeAmount > idoBalance ||
            processing
        )
    }

    const disabledRelockStakeButton = () => {
        return (
            stakingDisabled ||
            selectedId === "Select the Stake ID" ||
            Date.now() < currentStake?.releaseAt * 1000 ||
            !currentStake?.value ||
            processing
        )
    }

    const disabledCompStakeButton = () => {
        return stakingDisabled || selectedId === "Select the Stake ID" || processing
    }

    const disabledTransferButton = () => {
        return (oldStakes.length && oldSelectedId === "Select the Stake ID") || processing
    }

    const disabledTransferBalanceButton = () => {
        return idoBalance == 0 || processing
    }

    const getDate = (unixTimestamp) => {
        var options = { weekday: "long", year: "numeric", month: "long", day: "numeric" }
        let tsDate = unixTimestamp * 1000
        let date = new Date(tsDate)
        return <div>{date.toUTCString()}</div>
    }

    return (
        <React.Fragment>
            <div className="content staking-page">
                <BreadCrumb items={[pool.breadCrumb]} />
                {!isConnectedToWallet ? (
                    <ConnectWallet wallet={wallet} chainId={pool.chainId} onChange={updateConnection} />
                ) : isLoading ? (
                    <Modal isOpen={isLoading} centered={true}>
                        <ModalBody className="text-center h3">Loading...</ModalBody>

                        <ModalBody className="text-center">
                            <Spinner style={{ width: "0.7rem", height: "0.7rem" }} color="dark" />
                        </ModalBody>
                    </Modal>
                ) : (
                    <div className="staking-body">
                        {oldStakes.length > 0 && pool.igspv2 ? (
                            <Row>
                                <Col>
                                    <Card>
                                        <CardBody>
                                            <CardTitle className="h3">Transfer Stake Tokens</CardTitle>
                                            <Row>
                                                <Col lg={12}>
                                                    <CardText className="card-text-label text-uppercase mb-1">Warning </CardText>
                                                    <div className="card-text-value">
                                                        <p>This pool has been moved to zkSync Era network.</p>
                                                        <p>
                                                            For your convenience, you can transfer your stake Tokens to the idexo deployer address [
                                                            <strong>0x8142409931f554d99013de129cdDc70EA016d62d</strong>] to be processed in the new
                                                            stake pool.
                                                        </p>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Row className="contract-details mt-md-4 mb-md-4">
                                                        <Col md={6} className="mt-3 mt-md-0">
                                                            <CardText className="card-text-label text-uppercase">
                                                                Your {pool.tokenSymbol} Balance{" "}
                                                            </CardText>
                                                            <span className="card-text-value">{formatNumber(idoBalance, 5)}</span>
                                                        </Col>
                                                    </Row>

                                                    <Row>
                                                        <Col md={6} className="mt-3 mt-md-0">
                                                            <Button
                                                                className="btn submit-btn w-100 orange-btn text-uppercase"
                                                                onClick={() => handleTransferBalance()}
                                                                style={{ width: "100%" }}
                                                                disabled={disabledTransferBalanceButton()}
                                                            >
                                                                {!processing ? `Transfer ${pool.tokenSymbol}` : "Processing... "}
                                                                {processing ? (
                                                                    <Spinner style={{ width: "0.7rem", height: "0.7rem" }} color="light" />
                                                                ) : null}
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col>
                                                    <Row className="contract-details mt-md-4 mb-md-4">
                                                        <Col md={6} className="mt-3 mt-md-0">
                                                            <CardText className="card-text-label text-uppercase mb-1">
                                                                Stake Amount in the Pool
                                                            </CardText>
                                                            <div className="card-text-value">{formatNumber(oldStakeAmount, 5)}</div>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col md={6} className="mt-3 mt-md-0">
                                                            <label className="form-label text-uppercase mb-1">StakeToken Id</label>
                                                            <Input
                                                                disabled={!oldStakes.length || processing}
                                                                type="select"
                                                                value={oldSelectedId}
                                                                onChange={(e) => setOldSelectedId(e.target.value)}
                                                                className="form-control w-100 reward-token-id"
                                                                placeholder="Select Stake ID"
                                                            >
                                                                <option>Select the Stake ID</option>
                                                                {oldStakes.map((id) => (
                                                                    <option key={id.value}>{id.value}</option>
                                                                ))}
                                                            </Input>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col md={6} className="mt-3 mt-md-0">
                                                            <Button
                                                                className="btn submit-btn w-100 orange-btn text-uppercase"
                                                                onClick={() => handleTransfer(oldSelectedId)}
                                                                style={{ width: "100%" }}
                                                                disabled={disabledTransferButton()}
                                                            >
                                                                {!processing ? "Transfer Stake Token" : "Processing... "}
                                                                {processing ? (
                                                                    <Spinner style={{ width: "0.7rem", height: "0.7rem" }} color="light" />
                                                                ) : null}
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        ) : null}

                        <Row>
                            <Col>
                                <Card>
                                    <CardBody>
                                        <CardTitle className="h3">Contract Details</CardTitle>
                                        <Row>
                                            <Col lg={6}>
                                                <CardText className="card-text-label text-uppercase mb-1">Name </CardText>
                                                <div className="card-text-value">{contractDetails.name}</div>
                                            </Col>
                                        </Row>
                                        <Row className="contract-details mt-md-4 mb-md-4">
                                            {/* lg # defines how wide column is */}
                                            {/* lg = set breakpoint for large screen */}
                                            {/* md = set breakpoint for medium screen */}
                                            <Col md={4} className="mt-3 mt-md-0">
                                                <CardText className="card-text-label text-uppercase mb-1">Minimum Stake Amount </CardText>
                                                <div className="card-text-value">
                                                    {minimumAmountToStake} {pool.tokenSymbol}
                                                </div>
                                            </Col>
                                            <Col md={4} className="mt-3 mt-md-0">
                                                <CardText className="card-text-label text-uppercase mb-1">Symbol </CardText>
                                                <div className="card-text-value">{contractDetails.symbol}</div>
                                            </Col>
                                            <Col md={4} className="mt-3 mt-md-0">
                                                <CardText className="card-text-label text-uppercase mb-1">
                                                    Total Staked ({pool.tokenSymbol}){" "}
                                                </CardText>
                                                <div className="card-text-value">{totalStaked}</div>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <Card>
                                    <CardBody>
                                        <CardTitle className="h3">Your Details</CardTitle>

                                        <div className="align-items-center your-details">
                                            <div className="balance-stake-wrap">
                                                <div className="ido-balance">
                                                    <CardText className="card-text-label text-uppercase">Your {pool.tokenSymbol} Balance </CardText>
                                                    <span className="card-text-value">{formatNumber(idoBalance, 5)}</span>
                                                </div>

                                                <div className="stake-bg stake-ido">
                                                    <div className="d-flex flex-wrap align-items-center justify-content-between">
                                                        <div className="stake-bg-left">
                                                            <CardText className="card-text-label text-uppercase">Your STAKE </CardText>
                                                            <span className="card-text-value">{formatNumber(yourStakeAmount)}</span>
                                                        </div>
                                                        <div className="stake-bg-right">
                                                            <FormGroup>
                                                                <div className="select-balance">
                                                                    <CardText className="card-text-label text-uppercase">
                                                                        <span
                                                                            className="amount-value"
                                                                            onClick={
                                                                                stakingDisabled
                                                                                    ? null
                                                                                    : () => {
                                                                                          // set true to disable staking UI
                                                                                          setStakeAmount(idoBalance)
                                                                                      }
                                                                            }
                                                                        >
                                                                            max
                                                                        </span>
                                                                    </CardText>
                                                                </div>
                                                                <Input
                                                                    type="number"
                                                                    min={0}
                                                                    className="form-control w-100"
                                                                    value={stakeAmount}
                                                                    onFocus={(e) => e.target.select()}
                                                                    onChange={(e) => onRewardValueChange(e, "stake")}
                                                                    placeholder="Enter stake amount"
                                                                    disabled={stakingDisabled || processing}
                                                                ></Input>
                                                                <label className="form-label"> </label>
                                                                <Input
                                                                    disabled={stakingDisabled || processing}
                                                                    type="select"
                                                                    value={selectedType}
                                                                    onChange={(e) => setSelectedType(e.target.value)}
                                                                    className="form-control w-100 reward-token-id"
                                                                    placeholder="Select the Period"
                                                                >
                                                                    <option>Select the Period</option>

                                                                    {stakeTypes.map((id) => (
                                                                        <option key={id.value}>{id.value}</option>
                                                                    ))}
                                                                </Input>

                                                                <div></div>

                                                                {stakingDisabled ? null : showApproveButton() ? (
                                                                    <Button
                                                                        className="btn submit-btn w-100 orange-btn text-uppercase"
                                                                        onClick={() => handleApprove(stakeAmount)}
                                                                        style={{ width: "100%" }}
                                                                        disabled={stakingDisabled || disabledApproveButton()}
                                                                    >
                                                                        {!processing ? "Approve " + pool.tokenSymbol : "Processing... "}
                                                                        {processing ? (
                                                                            <Spinner style={{ width: "0.7rem", height: "0.7rem" }} color="light" />
                                                                        ) : null}
                                                                    </Button>
                                                                ) : null}
                                                                <Button
                                                                    className="btn submit-btn w-100 blue-btn text-uppercase"
                                                                    onClick={() => handleStake(stakeAmount)}
                                                                    style={{ width: "100%" }}
                                                                    disabled={stakingDisabled || disabledStakeButton()}
                                                                >
                                                                    {stakingDisabled
                                                                        ? "Pool Disabled"
                                                                        : pool.poolSymbol == "IGSPv2"
                                                                          ? "Closed Pool"
                                                                          : stakeAmount > idoBalance
                                                                            ? "Insufficient balance!"
                                                                            : !processing
                                                                              ? "Stake " + pool.tokenSymbol
                                                                              : "Processing... "}
                                                                    {processing ? (
                                                                        <Spinner style={{ width: "0.7rem", height: "0.7rem" }} color="light" />
                                                                    ) : null}
                                                                </Button>
                                                            </FormGroup>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="spacing"></div>

                                            <div className="your-details-right-box tokens-wrap">
                                                <div className="stake-bg d-flex flex-wrap justify-content-between div">
                                                    {rewardTokens.map((rewardToken) => {
                                                        return (
                                                            <div key={rewardToken.symbol} className="stake-bg-left tokens">
                                                                <CardText className="card-text-label text-uppercase">
                                                                    Available {rewardToken.symbol} Reward
                                                                </CardText>
                                                                {
                                                                    <div className="stake-bg-right tokens">
                                                                        <Table borderless>
                                                                            <tbody>
                                                                                {claimableRewards[rewardToken.symbol]
                                                                                    ? claimableRewards[rewardToken.symbol].map((item, idx) => {
                                                                                          return (
                                                                                              <tr
                                                                                                  className="your-details-table-row"
                                                                                                  key={`${item.symbol}-${idx}`}
                                                                                              >
                                                                                                  <td>ID {item.tokenId}: </td>
                                                                                                  <td>{formatNumber(item.reward)}</td>
                                                                                              </tr>
                                                                                          )
                                                                                      })
                                                                                    : null}
                                                                            </tbody>
                                                                        </Table>
                                                                    </div>
                                                                }
                                                            </div>
                                                        )
                                                    })}
                                                </div>

                                                <div className="stake-bg d-flex flex-wrap align-items-center justify-content-between">
                                                    <div className="stake-bg-right withdraw-reward">
                                                        <FormGroup>
                                                            <label className="form-label">stakeToken id</label>
                                                            <Input
                                                                disabled={!stakeIds.length || processing}
                                                                type="select"
                                                                value={selectedId}
                                                                onChange={(e) => setSelectedId(e.target.value)}
                                                                className="form-control w-100 reward-token-id"
                                                                placeholder="Select Stake ID"
                                                            >
                                                                <option>Select the Stake ID</option>
                                                                {stakeIds.map((id) => (
                                                                    <option key={id.value}>{id.value}</option>
                                                                ))}
                                                            </Input>
                                                            <div className="select-balance">
                                                                <CardText className="card-text-label text-uppercase">
                                                                    <span
                                                                        className="amount-value"
                                                                        onClick={() => {
                                                                            setClaimAmount(maxRewardsById)
                                                                        }}
                                                                    >
                                                                        max
                                                                    </span>
                                                                </CardText>
                                                            </div>

                                                            <Input
                                                                disabled={!(selectedId > 0) || !stakeIds.length || processing}
                                                                type="number"
                                                                min={0}
                                                                value={claimAmount}
                                                                onFocus={(e) => e.target.select()}
                                                                onChange={(e) => onRewardValueChange(e, "claim")}
                                                                className="form-control w-100"
                                                                placeholder="Enter reward amount"
                                                            ></Input>
                                                            {/* {maxRewardsById > 0 && <FormText>Maximum rewards for claim {maxRewardsById}</FormText>} */}

                                                            <Button
                                                                disabled={disabledClaimButton()}
                                                                color="success"
                                                                className="btn btn-primary submit-btn w-100 orange-btn text-uppercase"
                                                                onClick={() => handleClaim(selectedId, claimAmount)}
                                                                style={{ width: "100%" }}
                                                            >
                                                                {claimAmount > maxRewardsById
                                                                    ? "Insufficient balance!"
                                                                    : !processing
                                                                      ? "Withdraw Reward"
                                                                      : "Processing... "}
                                                                {processing ? (
                                                                    <Spinner style={{ width: "0.7rem", height: "0.7rem" }} color="light" />
                                                                ) : null}
                                                            </Button>
                                                        </FormGroup>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <Card>
                                    <CardBody>
                                        <CardTitle className="h3">Token Details</CardTitle>
                                        <Row className="stake-bg withdraw-stake-wrap">
                                            <FormGroup>
                                                <Row className="withdraw-stake">
                                                    <Col lg={4} className="col-md-6">
                                                        <label className="form-label">StakeToken ID</label>
                                                        <Input
                                                            disabled={!stakeIds.length || processing}
                                                            value={selectedId}
                                                            name="stakeIds"
                                                            id="stakeIds"
                                                            type="select"
                                                            onChange={(e) => {
                                                                setSelectedId(e.target.value)
                                                            }}
                                                        >
                                                            <option>Select the Stake ID</option>
                                                            {stakeIds.map((id) => (
                                                                <option key={id.value}>{id.value}</option>
                                                            ))}
                                                        </Input>
                                                    </Col>
                                                    <Col lg={4} className="col-xl-3 col-md-6 mt-3 mt-md-0">
                                                        <label className="form-label">Amount</label>

                                                        <Input
                                                            type="number"
                                                            min={0}
                                                            className="form-control"
                                                            value={addStakeAmount}
                                                            onFocus={(e) => e.target.select()}
                                                            onChange={(e) => {
                                                                onRewardValueChange(e, "add")
                                                                onRewardValueChange(e, "unstake")
                                                            }}
                                                            placeholder="Enter Amount"
                                                            disabled={stakingDisabled || !(selectedId > 0) || !stakeIds.length || processing}
                                                        ></Input>
                                                    </Col>
                                                    <Col lg={4} className="col-xl-3 mt-3 mt-lg-0">
                                                        {showAddApproveButton() ? (
                                                            <Button
                                                                className="btn submit-btn w-100 orange-btn text-uppercase"
                                                                onClick={() => handleApprove(addStakeAmount)}
                                                                style={{ width: "100%" }}
                                                                disabled={disabledAddApproveButton()}
                                                            >
                                                                {!processing ? "Approve " + pool.tokenSymbol + " to Add" : "Processing... "}
                                                                {processing ? (
                                                                    <Spinner style={{ width: "0.7rem", height: "0.7rem" }} color="light" />
                                                                ) : null}
                                                            </Button>
                                                        ) : null}

                                                        <label className="form-label d-none d-lg-block">&nbsp;</label>
                                                        {selectedId !== "Select the Stake ID" && !(Date.now() < currentStake?.releaseAt * 1000) ? (
                                                            <Button
                                                                className="btn btn-primary orange-btn text-uppercase"
                                                                onClick={() => handleUnStake(selectedId, unStakeAmount)}
                                                                disabled={disabledUnstakeButton()}
                                                                style={{ width: "100%" }}
                                                            >
                                                                {unStakeAmount > maxWithdrawById
                                                                    ? "Insufficient balance!"
                                                                    : !processing
                                                                      ? "Withdraw Stake"
                                                                      : "Processing... "}
                                                                {processing ? (
                                                                    <Spinner style={{ width: "0.7rem", height: "0.7rem" }} color="light" />
                                                                ) : null}
                                                            </Button>
                                                        ) : null}
                                                    </Col>
                                                </Row>
                                                {selectedId !== "Select the Stake ID" && currentStake?.value ? (
                                                    <Row>
                                                        <Col lg={4} className="col-xl-3 mt-3 mt-lg-0">
                                                            <label className="form-label d-none d-lg-block">&nbsp;</label>
                                                            <label className="form-label">Staked Amount</label>
                                                            {selectedId !== "Select the Stake ID" ? (
                                                                <div className="card-text-value">
                                                                    {formatNumber(web3.utils.fromWei(currentStake?.amount, "ether"))}
                                                                </div>
                                                            ) : null}
                                                        </Col>
                                                        <Col>
                                                            <label className="form-label d-none d-lg-block">&nbsp;</label>
                                                            <label className="form-label">Deposited At</label>
                                                            {selectedId !== "Select the Stake ID" ? (
                                                                <div className="card-text-value">{getDate(currentStake?.depositedAt)}</div>
                                                            ) : null}
                                                        </Col>
                                                        <Col>
                                                            <label className="form-label d-none d-lg-block">&nbsp;</label>
                                                            <label className="form-label">Days Staked</label>
                                                            {selectedId !== "Select the Stake ID" ? (
                                                                <div className="card-text-value">{currentStake?.period}</div>
                                                            ) : null}
                                                        </Col>
                                                        <Col>
                                                            {selectedId !== "Select the Stake ID" &&
                                                            !(Date.now() < currentStake?.releaseAt * 1000) ? (
                                                                <p></p>
                                                            ) : null}
                                                        </Col>
                                                    </Row>
                                                ) : null}
                                            </FormGroup>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </div>
                )}
            </div>
        </React.Fragment>
    )
}

export default StakingSOB
